import { z } from "zod/v4";

export const participantMetadata = z.object({
  userId: z.string().cuid(),
  image: z.string().url().nullable(),
  hasRaisedHand: z.boolean().optional(),
  isInvitedToStage: z.boolean().optional(),
});

export type ParticipantMetadata = z.infer<typeof participantMetadata>;

export function getParticipantMetadata(metadata: string | undefined) {
  const metaResult = participantMetadata.safeParse(
    JSON.parse(metadata || "{}"),
  );
  if (!metaResult.success) {
    return null;
  }

  return metaResult.data;
}
